<template>
  <div>
    <!-- 每周导入 -->
    <el-card class="box-card" style="margin:20px 40px;">
      <template #header>
        <span>周数据 · 每周导入</span>
      </template>
      <el-form :inline="true" label-width="90px">
        <el-form-item label="归属月">
          <el-date-picker v-model="importMonth" type="month" value-format="YYYY-MM" format="YYYY-MM"
                  placeholder="默认本月" style="width:170px"></el-date-picker>
          <div style="font-size:12px;color:#909399;line-height:1.4;margin-top:2px;">系统以文件内日期自动判定归属月，此处仅作默认/复核，填错仅提示不阻断</div>
        </el-form-item>
        <el-form-item label="归属周">
          <el-tag type="info">自动归周</el-tag>
          <div style="font-size:12px;color:#909399;line-height:1.4;margin-top:2px;">无需选择周次：系统按文件内日期自动归周，如 1~3 号的数据，1、2 号归第1周、3 号归第2周；跨周各归各周，有多少导多少，已有数据按日期覆盖</div>
        </el-form-item>
        <el-form-item label="xlsx">
          <el-upload
              ref="upload"
              :auto-upload="false"
              :show-file-list="true"
              :limit="1"
              accept=".xlsx,.xls"
              :on-change="onFileChange"
              style="width:300px">
            <el-button type="primary">选择文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="success" :loading="importing" @click="doImport">开始导入</el-button>
          <el-button type="primary" plain @click="downloadTemplate">下载导入模板</el-button>
        </el-form-item>
      </el-form>
      <el-alert v-if="importMsg" :title="importMsg" type="success" show-icon :closable="false"></el-alert>

      <!-- 源表公式损坏 / 教练未匹配城市组织 等必须显式告警, 不能静默成功 -->
      <el-alert v-for="(w, i) in warnings" :key="i" :title="w" type="warning" show-icon
                :closable="false" style="margin-top:8px;"></el-alert>

      <!-- 本次各指标实际入库合计, 内勤可与源表肉眼核对 -->
      <el-table v-if="totalRows.length" :data="totalRows" border size="small"
                style="margin-top:12px;max-width:520px;">
        <el-table-column prop="name" label="指标"></el-table-column>
        <el-table-column prop="value" label="本次入库合计">
          <template #default="s">{{ fmt2(s.row.value) }}</template>
        </el-table-column>
      </el-table>

      <!-- 每个 sheet 读到多少有效格 / 多少错误格, 用来定位是哪个 sheet 公式坏了 -->
      <el-table v-if="sheetDetail.length" :data="sheetDetail" border size="small"
                style="margin-top:12px;max-width:640px;">
        <el-table-column prop="sheet" label="sheet → 指标"></el-table-column>
        <el-table-column prop="valueCells" label="有效数值格"></el-table-column>
        <el-table-column prop="errorCells" label="错误格(#REF!等)">
          <template #default="s">
            <span :style="{ color: s.row.errorCells > 0 ? '#f56c6c' : '#67c23a' }">{{ s.row.errorCells }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top:10px;color:#888;font-size:12px;line-height:1.8;">
        说明：<br/>
        1) sheet 映射 —— <b>微信</b>(缺失时回退 微信明细)→微信添加，签约→签约，引流→引流，试客/试课→试课。<br/>
        2) 覆盖导入按<b>文件内实际包含的日期</b>删除并重写：同一文件<b>重复导入</b>幂等不重复；<b>补充导入</b>新一周(仅带新日期)时仅覆盖对应日期，旧周数据保留不丢。<br/>
        3) 无需在 Excel 里另存或重算公式，系统直接读取单元格缓存值；但<b>若源表某个 sheet 的公式是 #REF!，该指标只能按 0 入库</b>，需要出表人修好公式引用后重新下发。
      </div>
    </el-card>

    <!-- 日数据明细: 所选月+所选多周的日数据直接展示, 城市可多选 -->
    <el-card class="box-card" style="margin:20px 40px;">
      <template #header>
        <span>日数据明细（所选月 × 所选周 × 所选城市，某人某天的各项指标）</span>
      </template>
      <el-form :inline="true">
        <el-form-item label="归属月"><el-date-picker v-model="detailMonth" type="month" value-format="YYYY-MM" format="YYYY-MM" style="width:150px" @change="loadCities(detailMonth)"></el-date-picker></el-form-item>
        <el-form-item label="周(多选)">
          <el-select v-model="detailWeeks" multiple collapse-tags style="width:180px" placeholder="不选=全月">
            <el-option v-for="w in 6" :key="w" :label="w + '周'" :value="w"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="城市(多选)">
          <el-select v-model="detailCities" multiple filterable collapse-tags style="width:240px" placeholder="不选=全部城市">
            <el-option v-for="c in cities" :key="c.id" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" :loading="detailLoading" @click="loadDayDetail">查询明细</el-button></el-form-item>
      </el-form>
      <div v-if="detailRows.length" style="margin:4px 0 8px;font-size:13px;color:#606266;">
        共 <b>{{ detailRows.length }}</b> 行 · {{ detailStat.cityCnt }} 个城市 · {{ detailStat.coachCnt }} 名教练 ·
        微信添加 <b style="color:#7E4AD6;">{{ fmt2(detailStat.totals['微信添加']) }}</b> ·
        签约 <b style="color:#e6a23c;">{{ fmt2(detailStat.totals['签约']) }}</b> ·
        试课 <b style="color:#409EFF;">{{ fmt2(detailStat.totals['试课']) }}</b> ·
        引流 <b style="color:#67c23a;">{{ fmt2(detailStat.totals['引流']) }}</b>
        <span v-if="detailStat.unmatchedRows > 0" style="color:#f56c6c;margin-left:8px;">
          （另有 {{ detailStat.unmatchedRows }} 行教练未匹配到校区，未计入上方城市/教练数，可去掉城市筛选查看）
        </span>
      </div>
      <el-table :data="detailPaged" border size="small" v-loading="detailLoading">
        <el-table-column prop="cityName" label="城市" width="110">
          <template #default="s">{{ s.row.cityName || '未归属' }}</template>
        </el-table-column>
        <el-table-column prop="cityTypeName" label="城市类型" width="90"></el-table-column>
        <el-table-column prop="campusName" label="校区" show-overflow-tooltip></el-table-column>
        <el-table-column prop="deptName" label="所属组织" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="coachName" label="姓名" width="90"></el-table-column>
        <el-table-column prop="coachIdText" label="姓名ID" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="dataDate" label="日期" width="95"></el-table-column>
        <el-table-column label="周" width="60">
          <template #default="s">第{{ s.row.weekOfMonth }}周</template>
        </el-table-column>
        <el-table-column label="微信添加" width="95" align="right">
          <template #default="s">{{ fmt2(s.row.wechatAdd) }}</template>
        </el-table-column>
        <el-table-column label="签约" width="80" align="right">
          <template #default="s">{{ fmt2(s.row.signCnt) }}</template>
        </el-table-column>
        <el-table-column label="试课" width="80" align="right">
          <template #default="s">{{ fmt2(s.row.trialCnt) }}</template>
        </el-table-column>
        <el-table-column label="引流" width="80" align="right">
          <template #default="s">{{ fmt2(s.row.leadCnt) }}</template>
        </el-table-column>
      </el-table>
      <el-pagination v-if="detailRows.length > detailPageSize" background layout="total, prev, pager, next, sizes"
                     :total="detailRows.length" :page-size="detailPageSize" v-model:current-page="detailPage"
                     :page-sizes="[20, 50, 100]" style="margin-top:10px;"></el-pagination>
      <!-- 按城市小计(聚合当前筛选条件下全部明细, 不受分页影响) -->
      <el-collapse v-if="detailCityTotals.length" style="margin-top:14px;">
        <el-collapse-item title="按城市小计（当前筛选下各城市合计）">
          <el-table :data="detailCityTotals" border size="small" max-height="360">
            <el-table-column prop="cityName" label="城市" width="130"></el-table-column>
            <el-table-column label="微信添加" width="110" align="right">
              <template #default="s"><span style="color:#7E4AD6;font-weight:bold;">{{ s.row.wechatAdd }}</span></template>
            </el-table-column>
            <el-table-column label="签约" width="100" align="right">
              <template #default="s"><span style="color:#e6a23c;font-weight:bold;">{{ s.row.signCnt }}</span></template>
            </el-table-column>
            <el-table-column label="试课" width="100" align="right">
              <template #default="s"><span style="color:#409EFF;font-weight:bold;">{{ s.row.trialCnt }}</span></template>
            </el-table-column>
            <el-table-column label="引流" width="100" align="right">
              <template #default="s"><span style="color:#67c23a;font-weight:bold;">{{ s.row.leadCnt }}</span></template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <!-- 导入批次历史 -->
    <el-card id="historyCard" class="box-card" style="margin:20px 40px;">
      <template #header>
        <span>导入批次历史（每周谁导入）</span>
      </template>
      <el-form :inline="true">
        <el-form-item label="归属月">
          <el-date-picker v-model="historyMonth" type="month" value-format="YYYY-MM" format="YYYY-MM"
                  placeholder="留空=全部" style="width:170px" clearable></el-date-picker>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="loadHistory">查询</el-button></el-form-item>
        <el-form-item><el-button @click="historyMonth=null; loadHistory()">看全部</el-button></el-form-item>
      </el-form>
      <div style="font-size:12px;color:#909399;margin-bottom:6px;">归属周为该批数据的最大周次（跨周批次实际覆盖范围见导入时的结果提示）</div>
      <el-table :data="historyList" border size="small" row-key="rowKey"
                :expand-row-keys="expandKeys">
        <el-table-column type="expand">
          <template #default="s">
            <el-table :data="s.row.coverage" border size="mini" style="margin:8px 12px;max-width:680px;">
              <el-table-column prop="deptName" label="覆盖城市"></el-table-column>
              <el-table-column prop="coachCount" label="教练数" width="90"></el-table-column>
              <el-table-column prop="rowCount" label="明细行数" width="90"></el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="importMonth" label="归属月" width="90"></el-table-column>
        <el-table-column label="归属周" width="70">
          <template #default="s">第{{ s.row.importWeek }}周</template>
        </el-table-column>
        <el-table-column prop="fileName" label="文件名" show-overflow-tooltip></el-table-column>
        <el-table-column prop="operatorName" label="导入人" width="100"></el-table-column>
        <el-table-column prop="createTimeStr" label="导入时间" width="160"></el-table-column>
        <el-table-column prop="rowCount" label="行数" width="70"></el-table-column>
        <el-table-column label="覆盖城市数" width="100">
          <template #default="s">{{ (s.row.coverage || []).length }}</template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 月汇总导出 -->
    <el-card class="box-card" style="margin:20px 40px;">
      <template #header>
        <span>月汇总导出（最多6周）</span>
      </template>
      <el-form :inline="true">
        <el-form-item label="导出月"><el-date-picker v-model="exportMonth" type="month" value-format="YYYY-MM" format="YYYY-MM" style="width:160px" @change="loadExportWeeks(); loadCities(exportMonth)"></el-date-picker></el-form-item>
        <el-form-item label="导出城市">
          <el-select v-model="exportCities" multiple filterable collapse-tags style="width:260px" placeholder="不选=全集团(单sheet)">
            <el-option v-for="c in cities" :key="c.id" :label="c.name" :value="c.id"></el-option>
          </el-select>
          <div style="font-size:12px;color:#909399;line-height:1.4;margin-top:2px;">多选城市=每个城市一个 sheet 的汇总；不选=全集团一个 sheet</div>
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定导出该月汇总?" @confirm="doExport">
            <template #reference>
              <el-button type="warning">导出月汇总 xlsx</el-button>
            </template>
          </el-popconfirm>
        </el-form-item>
      </el-form>
      <!-- 该月已导入周次: 与批次历史联动, 点击展开对应批次 -->
      <div v-if="exportWeeks.length" style="margin:4px 0 8px;display:flex;align-items:center;flex-wrap:wrap;gap:8px;">
        <span style="font-size:13px;color:#606266;">该月已导入周次：</span>
        <el-tag v-for="w in exportWeeks" :key="w.week" :type="w.rowCount > 0 ? 'success' : 'info'"
                style="cursor:pointer;" @click="jumpToBatch(w)">
          第{{ w.week }}周 · {{ w.rowCount }}行 · {{ w.operatorName }}
        </el-tag>
        <span style="font-size:12px;color:#909399;">点击周次可查看该批导入详情</span>
      </div>
      <div v-else style="margin:4px 0 8px;font-size:13px;color:#e6a23c;">
        该月尚未导入过任何周数据，导出将为空表；请先在上方完成每周导入。
      </div>
    </el-card>

    <!-- 月汇总预览(网页查看, 与导出口径一致) -->
    <el-card class="box-card" style="margin:20px 40px;">
      <template #header>
        <span>月汇总预览（网页查看，按城市分组 + 城市小计，与导出一致）</span>
      </template>
      <el-form :inline="true">
        <el-form-item label="预览月"><el-date-picker v-model="viewMonth" type="month" value-format="YYYY-MM" format="YYYY-MM" style="width:160px" @change="loadCities(viewMonth)"></el-date-picker></el-form-item>
        <el-form-item label="城市(多选)">
          <el-select v-model="viewCities" multiple filterable collapse-tags style="width:260px" placeholder="不选=全集团">
            <el-option v-for="c in cities" :key="c.id" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" :loading="monthViewLoading" @click="loadMonthView">查询预览</el-button></el-form-item>
      </el-form>
      <el-table v-if="monthViewRows.length" :data="monthViewRows" border size="small" v-loading="monthViewLoading" max-height="520">
        <el-table-column prop="cityName" label="城市" width="120" fixed></el-table-column>
        <el-table-column prop="cityTypeName" label="城市类型" width="90" fixed></el-table-column>
        <el-table-column prop="coachName" label="姓名" width="90" fixed></el-table-column>
        <el-table-column prop="coachIdText" label="姓名ID" width="130" fixed show-overflow-tooltip></el-table-column>
        <el-table-column v-for="w in monthViewWeekLabels" :key="w.idx" :label="w.label">
          <el-table-column label="微信添加" align="right" width="78">
            <template #default="s">{{ fmt2(s.row.weeks[w.idx-1] ? s.row.weeks[w.idx-1].wechatAdd : 0) }}</template>
          </el-table-column>
          <el-table-column label="签约" align="right" width="70">
            <template #default="s">{{ fmt2(s.row.weeks[w.idx-1] ? s.row.weeks[w.idx-1].sign : 0) }}</template>
          </el-table-column>
          <el-table-column label="试课" align="right" width="70">
            <template #default="s">{{ fmt2(s.row.weeks[w.idx-1] ? s.row.weeks[w.idx-1].trial : 0) }}</template>
          </el-table-column>
          <el-table-column label="引流" align="right" width="70">
            <template #default="s">{{ fmt2(s.row.weeks[w.idx-1] ? s.row.weeks[w.idx-1].lead : 0) }}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="合计-微信添加" align="right" width="95">
          <template #default="s"><span style="color:#7E4AD6;font-weight:bold;">{{ s.row.totalWechatAdd }}</span></template>
        </el-table-column>
        <el-table-column label="合计-签约" align="right" width="85">
          <template #default="s"><span style="color:#e6a23c;font-weight:bold;">{{ s.row.totalSign }}</span></template>
        </el-table-column>
        <el-table-column label="合计-试课" align="right" width="85">
          <template #default="s"><span style="color:#409EFF;font-weight:bold;">{{ s.row.totalTrial }}</span></template>
        </el-table-column>
        <el-table-column label="合计-引流" align="right" width="85">
          <template #default="s"><span style="color:#67c23a;font-weight:bold;">{{ s.row.totalLead }}</span></template>
        </el-table-column>
      </el-table>
      <el-collapse v-if="monthViewCityTotals.length" style="margin-top:14px;">
        <el-collapse-item title="按城市小计（该月各城市合计）">
          <el-table :data="monthViewCityTotals" border size="small" max-height="360">
            <el-table-column prop="cityName" label="城市" width="130"></el-table-column>
            <el-table-column prop="cityTypeName" label="城市类型" width="90"></el-table-column>
            <el-table-column label="微信添加" align="right" width="110">
              <template #default="s"><span style="color:#7E4AD6;font-weight:bold;">{{ s.row.wechatAdd }}</span></template>
            </el-table-column>
            <el-table-column label="签约" align="right" width="100">
              <template #default="s"><span style="color:#e6a23c;font-weight:bold;">{{ s.row.sign }}</span></template>
            </el-table-column>
            <el-table-column label="试课" align="right" width="100">
              <template #default="s"><span style="color:#409EFF;font-weight:bold;">{{ s.row.trial }}</span></template>
            </el-table-column>
            <el-table-column label="引流" align="right" width="100">
              <template #default="s"><span style="color:#67c23a;font-weight:bold;">{{ s.row.lead }}</span></template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
      <div v-if="!monthViewRows.length && !monthViewLoading" style="font-size:13px;color:#909399;">选择一个月份后点击「查询预览」，即可在网页直接查看月汇总（按城市分组 + 城市小计），与导出 Excel 口径一致。</div>
    </el-card>
  </div>
</template>

<script>
import { importWeekly, monthSummaryExport, importHistory, importedCityList, dayDetail, monthSummaryView } from '@/api/cityDailyData';

export default {
  data() {
    return {
      importMonth: '',
      file: null,
      importing: false,
      importMsg: '',
      warnings: [],
      totalRows: [],
      sheetDetail: [],
      exportMonth: '',
      // 月汇总预览(网页查看, 与导出口径一致)
      viewMonth: '',
      viewCities: [],
      monthViewLoading: false,
      monthViewRows: [],
      monthViewWeekLabels: [],
      // 导入批次历史
      historyMonth: '',
      historyList: [],
      expandKeys: [],
      // 导出页"该月已导入周次"联动
      exportWeeks: [],
      exportCities: [], // 导出城市多选, 空=全集团
      // 城市清单(area.type=2)
      cities: [],
      // 日数据明细
      detailMonth: '',
      detailWeeks: [],
      detailCities: [],
      detailLoading: false,
      detailRows: [],
      detailStat: { totals: {}, cityCnt: 0, coachCnt: 0, unmatchedRows: 0 },
      detailPage: 1,
      detailPageSize: 20
    };
  },
  computed: {
    // 按城市小计(聚合当前筛选下全部明细, 不受分页影响): 系统归属城市 + 四指标合计
    detailCityTotals() {
      const map = {}
      this.detailRows.forEach(r => {
        const k = r.cityName || '未归属'
        if (!map[k]) map[k] = { cityName: k, wechatAdd: 0, signCnt: 0, trialCnt: 0, leadCnt: 0 }
        const t = map[k]
        t.wechatAdd += Number(r.wechatAdd || 0); t.signCnt += Number(r.signCnt || 0)
        t.trialCnt += Number(r.trialCnt || 0); t.leadCnt += Number(r.leadCnt || 0)
      })
      return Object.keys(map).map(k => ({
        cityName: k,
        wechatAdd: this.fmt2(map[k].wechatAdd), signCnt: this.fmt2(map[k].signCnt),
        trialCnt: this.fmt2(map[k].trialCnt), leadCnt: this.fmt2(map[k].leadCnt)
      }))
    },
    // 月汇总预览: 按城市小计(聚合该月全部教练行, 系统归属城市)
    monthViewCityTotals() {
      const map = {}
      this.monthViewRows.forEach(r => {
        const k = r.cityName || '未归属'
        if (!map[k]) map[k] = { cityName: k, cityTypeName: r.cityTypeName || '',
          wechatAdd: 0, sign: 0, trial: 0, lead: 0 }
        const t = map[k]
        t.wechatAdd += Number(r.rawTotalWechatAdd || 0); t.sign += Number(r.rawTotalSign || 0)
        t.trial += Number(r.rawTotalTrial || 0); t.lead += Number(r.rawTotalLead || 0)
      })
      return Object.keys(map).map(k => ({
        cityName: k, cityTypeName: map[k].cityTypeName,
        wechatAdd: this.fmt2(map[k].wechatAdd), sign: this.fmt2(map[k].sign),
        trial: this.fmt2(map[k].trial), lead: this.fmt2(map[k].lead)
      }))
    },
    detailPaged() {
      const s = (this.detailPage - 1) * this.detailPageSize;
      return this.detailRows.slice(s, s + this.detailPageSize);
    }
  },
  created() {
    const now = new Date();
    const m = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0');
    this.importMonth = this.exportMonth = this.historyMonth = this.detailMonth = this.viewMonth = m;
    this.loadHistory();
    this.loadExportWeeks();
    this.loadCities(this.detailMonth);
  },
  methods: {
    // 指标统一两位小数 + 千分位(对齐"个数/金额一律保留两位小数"口径; BigDecimal 经 JSON 会丢尾随零, 前端补回)
    fmt2(v) {
      if (v === null || v === undefined || v === '') return ''
      const n = Number(v)
      if (isNaN(n)) return v
      return n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    onFileChange(file) {
      this.file = file.raw;
    },
    // 导入模板直接下载 MinIO 上的模板文件; 加随机参数强制拉取最新模板, 避免缓存旧版
    downloadTemplate() {
      const url = 'https://minio.yanhuotiyu.com/yhoss/web/%E5%91%A8%E6%95%B0%E6%8D%AE%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF_2026-08.xlsx'
          + '?r=' + Math.random().toString(36).slice(2);
      window.open(url, '_blank');
    },
    doImport() {
      if (!this.file) { this.$message.warning('请先选择 xlsx'); return; }
      if (!this.importMonth) { this.$message.warning('请填写归属月'); return; }
      const fd = new FormData();
      fd.append('file', this.file);
      fd.append('importMonth', this.importMonth);
      // 不传归属周: 系统按文件内日期自动归周
      this.importing = true;
      this.importMsg = '';
      this.warnings = [];
      this.totalRows = [];
      this.sheetDetail = [];
      importWeekly(fd).then(res => {
        if (res.code === 200) {
          const d = res.data || {};
          const cov = d.coverage || [];
          const wks = d.weeksInFile || [];
          this.importMsg = `导入成功：共 ${d.rowCount} 行，归属 ${d.importMonth}，`
              + `数据覆盖第${wks.join('、')}周，`
              + `覆盖 ${cov.length} 个城市，覆盖前清理旧数据 ${d.removedRows || 0} 行`;
          this.warnings = d.warnings || [];
          this.sheetDetail = d.sheetDetail || [];
          const t = d.totals || {};
          this.totalRows = Object.keys(t).map(k => ({ name: k, value: t[k] }));
          // 归属月以服务端实际判定为准回填, 消除"填错仅告警"的误导
          this.importMonth = d.importMonth || this.importMonth;
          // 批次历史与导出页周次联动同步刷新, 内勤无需手动再查
          this.historyMonth = d.importMonth || this.historyMonth;
          this.loadHistory();
          this.loadExportWeeks();
          this.loadCities(d.importMonth);
          if (this.warnings.length) this.$message.warning('导入完成，但有 ' + this.warnings.length + ' 项需要注意');
          else this.$message.success('导入成功');
        } else {
          this.$message.error(res.msg || '导入失败');
        }
      }).catch(() => {
        this.$message.error('导入请求失败，请检查文件与网络');
      }).finally(() => { this.importing = false; });
    },
    doExport() {
      if (!this.exportMonth) { this.$message.warning('请填写导出月'); return; }
      const q = { importMonth: this.exportMonth };
      if (this.exportCities && this.exportCities.length) q.cityIds = this.exportCities.join(',');
      monthSummaryExport(q);
      this.$message.info(this.exportCities.length
          ? '已按 ' + this.exportCities.length + ' 个城市分 sheet 触发导出，稍后在下载中心查看'
          : '已触发全集团导出，稍后在下载中心查看');
    },
    // ---- 月汇总预览(网页查看) ----
    loadMonthView() {
      if (!this.viewMonth) { this.$message.warning('请填写预览月'); return; }
      this.monthViewLoading = true
      const q = { importMonth: this.viewMonth }
      if (this.viewCities && this.viewCities.length) q.cityIds = this.viewCities.join(',')
      monthSummaryView(q).then(res => {
        if (res.code === 200) {
          const d = res.data || {}
          const wl = d.weekLabels || {}
          this.monthViewWeekLabels = Object.keys(wl).map(k => ({ idx: Number(k), label: wl[k] }))
            .sort((a, b) => a.idx - b.idx)
          this.monthViewRows = (d.rows || []).map(r => ({
            ...r,
            cityName: r.cityName || '未归属',
            cityTypeName: r.cityTypeName || '',
            weeks: (r.weeks || []).map(w => ({
              wechatAdd: this.fmt2(w.wechatAdd), sign: this.fmt2(w.sign),
              trial: this.fmt2(w.trial), lead: this.fmt2(w.lead)
            })),
            totalWechatAdd: this.fmt2(r.totalWechatAdd), totalSign: this.fmt2(r.totalSign),
            totalTrial: this.fmt2(r.totalTrial), totalLead: this.fmt2(r.totalLead),
            rawTotalWechatAdd: r.totalWechatAdd, rawTotalSign: r.totalSign,
            rawTotalTrial: r.totalTrial, rawTotalLead: r.totalLead
          }))
          if (!this.monthViewRows.length) this.$message.info('该月暂无导入数据')
        } else {
          this.$message.error(res.msg || '预览失败')
        }
      }).catch(() => {
        this.$message.error('预览请求失败')
      }).finally(() => { this.monthViewLoading = false })
    },
    // ---- 城市清单(只查当月已导入城市) ----
    loadCities(month) {
      const m = month || this.detailMonth;
      if (!m) { this.cities = []; return; }
      importedCityList({ importMonth: m }).then(res => {
        if (res.code === 200) this.cities = res.data || [];
      });
    },
    // ---- 日数据明细 ----
    loadDayDetail() {
      if (!this.detailMonth) { this.$message.warning('请填写归属月'); return; }
      this.detailLoading = true;
      this.detailPage = 1;
      // 多选数组为空时不传该参数(空=全部), 避免空串导致后端 List 绑定歧义
      const q = { importMonth: this.detailMonth };
      if (this.detailWeeks && this.detailWeeks.length) q.importWeeks = this.detailWeeks.join(',');
      if (this.detailCities && this.detailCities.length) q.cityIds = this.detailCities.join(',');
      dayDetail(q).then(res => {
        if (res.code === 200) {
          const d = res.data || {};
          this.detailRows = d.rows || [];
          this.detailStat = { totals: d.totals || {}, cityCnt: d.cityCnt || 0,
                              coachCnt: d.coachCnt || 0, unmatchedRows: d.unmatchedRows || 0 };
          if (!this.detailRows.length) this.$message.info('该筛选条件下没有日数据');
        } else {
          this.$message.error(res.msg || '明细查询失败');
        }
      }).finally(() => { this.detailLoading = false; });
    },
    // ---- 导入批次历史 ----
    parseTime(t) {
      if (!t) return '';
      const d = new Date(t);
      if (isNaN(d.getTime())) return String(t);
      const p = n => String(n).padStart(2, '0');
      return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
          + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
    },
    loadHistory() {
      importHistory({ importMonth: this.historyMonth || '' }).then(res => {
        if (res.code === 200) {
          const list = res.data || [];
          this.historyList = list.map(x => {
            let cov = [];
            try { cov = x.deptCoverage ? JSON.parse(x.deptCoverage) : []; } catch (e) { cov = []; }
            return { ...x, coverage: cov, createTimeStr: this.parseTime(x.createTime),
                     rowKey: String(x.id) };
          });
        } else {
          this.$message.error('批次历史查询失败');
        }
      });
    },
    // ---- 导出页"该月已导入周次"联动 ----
    loadExportWeeks() {
      if (!this.exportMonth) { this.exportWeeks = []; return; }
      importHistory({ importMonth: this.exportMonth }).then(res => {
        if (res.code !== 200) { this.exportWeeks = []; return; }
        const list = res.data || [];
        // 同一周可能有多次批次(重复/补充导入), 取最新一次作为展示
        const byWeek = {};
        list.forEach(x => {
          const w = x.importWeek;
          if (!byWeek[w] || (x.createTime || '') > (byWeek[w].createTime || '')) byWeek[w] = x;
        });
        this.exportWeeks = Object.keys(byWeek)
            .map(w => ({ week: Number(w), rowCount: byWeek[w].rowCount || 0,
                         operatorName: byWeek[w].operatorName || '-', batchId: byWeek[w].id }))
            .sort((a, b) => a.week - b.week);
      });
    },
    // 点击周次 chip -> 联动批次历史卡片展开对应批次
    jumpToBatch(w) {
      this.historyMonth = this.exportMonth;
      this.loadHistory();
      this.expandKeys = [String(w.batchId)];
      this.$message.info('已定位 ' + this.exportMonth + ' 第' + w.week + '周批次，在下方批次历史卡片中展开');
      this.$nextTick(() => {
        const el = document.getElementById('historyCard');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }
};
</script>

<style scoped>
.box-card { border-radius: 8px; }
</style>
